import { render, staticRenderFns } from "./AxCardTitle.vue?vue&type=template&id=b7748c70&scoped=true"
import script from "./AxCardTitle.vue?vue&type=script&lang=ts"
export * from "./AxCardTitle.vue?vue&type=script&lang=ts"
import style0 from "./AxCardTitle.vue?vue&type=style&index=0&id=b7748c70&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7748c70",
  null
  
)

export default component.exports